// utils/formatSort.js

/**
 * Formats a sort string by converting the first word to lowercase
 * and capitalizing the first letter of subsequent words.
 * Special case for "Best Sellers" which should be converted to "topPurchased"
 *
 * @param {string} sort - The string to format.
 * @returns {string} - The formatted string.
 */
export const formatSort = (sort:string) => {
    if (sort === "Best Sellers") {
        return "topPurchased";
    }
    return sort
      .split(" ")
      .map((word, index) =>
        index === 0
          ? word.toLowerCase()
          : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
      )
      .join("");
};
  